import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { PortfolioService } from '../../../../../core/services/api/portfolio.service';
import { ElementRef } from '@angular/core';
@Component({
    selector: 'app-tax-exemption-preview',
    templateUrl: './tax-exemption-preview.component.html',
    styleUrls: ['./tax-exemption-preview.component.scss'],
    standalone: false
})
export class TaxExemptionPreviewComponent {
  constructor(
    public dialogRef: MatDialogRef<TaxExemptionPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private portfolioService: PortfolioService,
    private el: ElementRef,
  ) {}

  close() {
    this.dialogRef.close();
  }

  generate() {
    const id = this.data?.id;
    if (id) {
      const url = this.portfolioService.getTaxExemptionCertificatePdfUrl(id);
      window.open(url);
    }
    this.dialogRef.close();
  }
}
